//js code for swapping main gallery image to the clicked thumbnail

(function() {

	$( '.image-gallery-thumbnail' ).on( 'click', function () {

		var targetImage = $( this ).data( 'image' );
		var targetCaption = $( this ).data( 'caption' );
		var targetDot = $( this ).data( 'dot' );

		$( '.image-gallery-thumbnail' ).each( function( index, thumbnail ) {

			$( thumbnail ).removeClass( 'border-2 border-solid border-blue-default' );

		});

		$( '.image-gallery-dot' ).each( function( index, dot ) {

			$( dot ).removeClass( 'bg-blue-checked' );

		});

		$( '.image-gallery-main-image' ).each( function( index, image ) {

			$( image ).removeClass( 'block' );

			if( ! $( image ).hasClass( 'hidden' ) ) {

				$( image ).addClass( 'hidden' );

			}


		});

		$( '.gallery-caption' ).each( function( index, caption ) {

			$( caption ).removeClass( 'block' );
			$( caption ).addClass( 'hidden' );

		});

		$( 'iframe' ).each( function( index, video ) {

			var src= $( this ).attr( 'src' );
			$( this ).attr( 'src',src );

		});

		$( this ).addClass( 'border-2 border-solid border-blue-default' );
		$( targetImage ).addClass( 'block' );
		$( targetImage ).removeClass( 'hidden' );
		$( targetCaption ).addClass( 'block' );
		$( targetCaption ).removeClass( 'hidden' );
		$( targetDot ) .addClass( 'bg-blue-checked' );

	});

	$( '.image-gallery-dot' ).on( 'click', function () {

		var targetImage = $( this ).data( 'image' );
		var targetCaption = $( this ).data( 'caption' );
		var targetThumbnail = $( this ).data( 'thumbnail' );

		$( '.image-gallery-thumbnail' ).each( function( index, thumbnail ) {

			$( thumbnail ).removeClass( 'border-2 border-solid border-blue-default' );

		});

		$( '.image-gallery-dot' ).each( function( index, dot ) {

			$( dot ).removeClass( 'bg-blue-checked' );

		});

		$( '.image-gallery-main-image' ).each( function( index, image ) {

			$( image ).removeClass( 'block' );
			$( image ).addClass( 'hidden' );

		});

		$( '.gallery-caption' ).each( function( index, caption ) {

			$( caption ).removeClass( 'block' );
			$( caption ).addClass( 'hidden' );

		});

		$( this ).addClass( 'bg-blue-checked' );
		$( targetImage ).addClass( 'block' );
		$( targetImage ).removeClass( 'hidden' );
		$( targetCaption ).addClass( 'block' );
		$( targetCaption ).removeClass( 'hidden' );
		$( targetThumbnail ).addClass( 'border-2 border-solid border-blue-default' );

	});


})();
